import styled from "@emotion/styled";
import { useMemo } from "react";
import { CYCLE_COLORS } from "../../utils/Service/colors";

const CycleBar = ({
  showSubTitle = false,
  subTitle,
  cycleIds = [],
  cycles = [],
}) => {
  const cycleById = useMemo(() => {
    const map = {};

    cycles.forEach((cycle) => {
      map[cycle.id] = cycle;
    });
    return map;
  }, [cycles]);

  const selectedCards = useMemo(() => {
    return cycleIds
      .map((id, index) => {
        const cycle = cycleById[id];
        if (!cycle) return null;

        return {
          ...cycle,
          id,
          color: CYCLE_COLORS[index % CYCLE_COLORS.length].main,
        };
      })
      .filter(Boolean);
  }, [cycleIds, cycleById]);

  return (
    <PickerBar className="">
      {showSubTitle && <span className="picker-label">{subTitle}</span>}
      <CycleList>
        {selectedCards.map((cycle) => (
          <CycleChip key={cycle.id} color={cycle.color}>
            <Dot color={cycle.color} />

            <CycleText>
              <span className="chip-name">{cycle.name}</span>
              <span className="chip-month">{cycle.date}</span>
            </CycleText>
          </CycleChip>
        ))}
      </CycleList>
    </PickerBar>
  );
};

const CycleList = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

const CycleText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const PickerBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px;
  border: 1px solid #dde1e6;
  border-radius: 8px;
  background-color: #fafbfc;

  .picker-label {
    font-size: 0.8rem;
    font-weight: 700;
    color: #353e4c;
    white-space: nowrap;
  }
`;

const CycleChip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 6px 12px;

  border: 1px solid ${(props) => props.color}33;
  border-radius: 8px;
  background-color: #ffffff;

  box-sizing: border-box;

  .chip-name {
    display: block;
    font-size: 0.78rem;
    font-weight: 700;
    color: #0f2a3d;
    line-height: 1.1;
    white-space: nowrap;
  }

  .chip-month {
    display: block;
    font-size: 0.72rem;
    color: #6b7280;
    line-height: 1.1;
  }
`;

const Dot = styled.span`
  display: block;
  width: 9px;
  min-width: 9px;
  height: 9px;
  min-height: 9px;
  border-radius: 50%;
  background-color: ${(props) => props.color || "#007dc1"};
  flex-shrink: 0;
`;
export default CycleBar;
